import axios from "axios";
import Config from "../../utils/Config";
const BASE_URL = `${Config.baseUrl}api/`;

class LandingPageRequests {
  getHeaders() {
    return {
      headers: {
        "Content-Type": "application/json",
      },
    };
  }

  async getSubscriptionPlans() {
    try {
      const response = await axios.get(
        `${BASE_URL}all_plans`,
        this.getHeaders()
      


      );
      //console.log(response.data.data);
      return {
        success: true,
        message: "Subscription plans fetched successfully",
        data: response.data.data,
      };
    } catch (error) {
      return {
        success: false,
        message: "Error fetching subscription plans",
        error: error.response?.data?.message || "An error occurred",
      };
    }
  }
}
const landingPageRequests = new LandingPageRequests();
export default landingPageRequests;
